import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    value: false,
    eventIdx: null,
};
export const policySlice = createSlice({
    name: "policy",
    initialState: initialState,
    reducers: {
        showPolicy: (state, action) => {
            state.value = true;
            state.eventIdx = action.payload || null;
        },
        hidePolicy: state => {
            state.value = false;
            state.eventIdx = null;
        },
    }
})

export const {showPolicy, hidePolicy} = policySlice.actions;
export default policySlice.reducer;